import { connect } from 'react-redux';
import { getDeviationById } from '@wix/da-shared-react/pkg/redux/deviations/selectors';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags/selectors';
import { AppState } from '../../../../types/store';
import { getModuleData, getModuleVersion } from '../../../selectors/modules';
import { DEFAULT_COLOR } from './constants';

export default connect((state: AppState, ownProps) => {
  const moduleVersion = getModuleVersion(state, ownProps.moduleId);
  const moduleData = getModuleData(state, ownProps.moduleId);
  const image = getDeviationById(state, moduleData.image);
  const customboxThemeDefaults = flagEnabled(state, 'custombox_theme_defaults');
  const {
    customtext,
    backgroundType,
    imageDisplayMode,
    imageTint,
    pattern,
    gradient,
  } = moduleData;
  const defaultColor = customboxThemeDefaults ? undefined : DEFAULT_COLOR;
  const color = moduleData.color || defaultColor;
  return {
    ...moduleData,
    moduleVersion,
    image,
    customtext,
    backgroundType,
    imageDisplayMode,
    imageTint,
    pattern,
    gradient,
    color,
  };
});
